export type AdminEventType = 'api_payment' | 'tax' | 'subscription' | 'maintenance' | 'meeting' | 'other';

export interface AdminEvent {
  id: string;
  user_id: string;
  title: string;
  description: string | null;
  event_type: AdminEventType;
  event_date: string;
  end_date: string | null;
  color: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface CreateAdminEventInput {
  title: string;
  description?: string;
  event_type: AdminEventType;
  event_date: string;
  end_date?: string;
  color?: string;
}

export interface UpdateAdminEventInput {
  title?: string;
  description?: string;
  event_type?: AdminEventType;
  event_date?: string;
  end_date?: string;
  color?: string;
}

export const ADMIN_EVENT_TYPE_LABELS: Record<AdminEventType, string> = {
  api_payment: 'API Payment',
  tax: 'Tax',
  subscription: 'Subscription',
  maintenance: 'Maintenance',
  meeting: 'Meeting',
  other: 'Other',
};

export const ADMIN_EVENT_TYPE_COLORS: Record<AdminEventType, string> = {
  api_payment: '#f97316',
  tax: '#ef4444',
  subscription: '#8b5cf6',
  maintenance: '#3b82f6',
  meeting: '#22c55e',
  other: '#6b7280',
};

export interface MonthlyFinancial {
  month: string;
  earnings: number;
  expenses: number;
}

export interface FinancialSummary {
  year: number;
  total_earnings: number;
  total_expenses: number;
  net_profit: number;
  monthly: MonthlyFinancial[];
}
